export enum CardChartsTranslateKeys {}

const frauen = 'i18n.common.frauen';
const maenner = 'i18n.common.maenner';

export const CHARTS_TRANSLATOR = {
  personalbestandserie: [maenner, frauen],
  gesamtverdienstundlohnbestandteile: [
    'i18n.cockpit.card.chart.gesamtverdienstLohn.sonderzahlungen',
    'i18n.cockpit.card.chart.gesamtverdienstLohn.13-Monatslohn1-12',
    'i18n.cockpit.card.chart.gesamtverdienstLohn.zulagen',
    'i18n.cockpit.card.chart.gesamtverdienstLohn.grundlohn',
    frauen,
    maenner,
    'i18n.cockpit.card.chart.gesamtverdienstLohn.lohnbestandteileInCHF'
  ],
  lohnverteilung: [
    'i18n.cockpit.card.chart.lohnverteilung.title',
    'i18n.cockpit.card.chart.lohnverteilung.quartil1',
    'i18n.cockpit.card.chart.lohnverteilung.quartil2',
    'i18n.cockpit.card.chart.lohnverteilung.quartil3',
    'i18n.cockpit.card.chart.lohnverteilung.quartil4',
    maenner,
    frauen
  ],
  personenundstellenbezogenemerkmale: [maenner, frauen],
  funktionenstellenbezogenemerkmale: [maenner, frauen],
  personalaufwand: [
    'i18n.cockpit.card.chart.personalaufwand.lohnsummeNachGeschlecht',
    'i18n.cockpit.card.chart.personalaufwand.effektiv',
    'i18n.cockpit.card.chart.personalaufwand.standardisiert',
    'i18n.cockpit.card.chart.personalaufwand.ohneArbeitgeberbetraege',
    maenner,
    frauen
  ],
  durchschnittlicherBeschaeftigungsgrad: [maenner, frauen],
  kompetenzniveau: [maenner, frauen],
  anzahlAnteilMitarbeitende: [maenner, frauen],
  kennzahlenzurmethodik: [maenner, frauen],
  funktionswert: [
    'm2.sprint3.cockpit.card.chart.funktionswert.linear',
    'm2.sprint3.cockpit.card.chart.funktionswert.monatslohn',
    'm2.sprint3.cockpit.card.chart.funktionswert.x-Achse',
    'i18n.common.maenner',
    'i18n.common.frauen'
  ],
  chartDialogGrafischerModellcheck: [
    'm1.sprint5.cockpit.card.grafischerModellcheck.content.1',
    'm1.sprint5.cockpit.card.grafischerModellcheck.content.2',
    'i18n.common.maenner',
    'i18n.common.frauen'
  ],
  qqPlot: [
    'm1.sprint5.cockpit.card.chart.grafischerModellcheck.qqPlot.title',
    'm1.sprint5.cockpit.card.chart.grafischerModellchek.qqPlot.x-Achse',
    'm1.sprint5.cockpit.card.chart.grafischerModellcheck.qqPlot.y-Achse',
    maenner,
    frauen
  ],
  residualsVsFitted: [
    'm1.sprint5.cockpit.card.chart.grafischerModellcheck.residualsVsFitted.title',
    'm1.sprint5.cockpit.card.chart.grafischerModellchek.residualsVsFitted.x-Achse',
    'm1.sprint5.cockpit.card.chart.grafischerModellcheck.residualsVsFitted.y-Achse',
    maenner,
    frauen
  ],
  risikopaare: [
    'm2.sprint2.cockpit.card.kennzahlenMethodik.risikopaare.test1+2',
    'm2.sprint2.cockpit.card.kennzahlenMethodik.risikopaare.test1+3',
    'm2.sprint2.cockpit.card.kennzahlenMethodik.risikopaare.test2+3',
    'm2.sprint2.cockpit.card.kennzahlenMethodik.risikopaare.test1+2+3'
  ],
  leaveOneOut: [
    'm2.ergebnis.robustheitsmass.subtitle',
    'm2.ergebnis.robustheitsmass.frequency',
    'm2.ergebnis.robustheitsmass.xAxis.title',
    'm2.ergebnis.robustheitsmass.title',
    'm2.ergebnis.robustheitsmass.scoreglobal',
    'm2.ergebnis.robustheitsmass.tooltip.xAxis.text'
  ]
};

export enum CockpitTabIndex {
  TabStandard = 0,
  TabKontrolle = 1
}

export const GESTAPELT = 'Gestapelt';
export const UNGESTAPELT = 'UnGestapelt';
export const ABSOLUT = 'Absolut';
export const ANTEIL = 'Anteil';
export const DURSCHNITT = 'Durschnitt';
export const VAE = 'Vae';
